import { Route } from '@/constants';
import { SignIn } from '@/modules/authentication/sign-in';

export const publicRoutes = [
    {
        key: 'signIn',
        path: Route.SIGN_IN,
        component: <SignIn />,
        index: true,
        authority: [],
    },
];
